module.exports = __webpack_public_path__ + "static/media/mechanic.f53a4af2.jpg";